import PropTypes from 'prop-types';
import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import TopicShape from '../propTypes/TopicShape';
import topicPath from '../utils/url/topicPath';
import styles from './ContentMapColumnBreadcrumbs.module.scss';
import ContentMapColumnHeader from './ContentMapColumnHeader';

const propTypes = {
  movedIn: PropTypes.bool.isRequired,
  link: PropTypes.bool.isRequired,
  breadcrumbs: PropTypes.arrayOf(TopicShape).isRequired,
};

const ContentMapColumnBreadcrumbs = ({ movedIn, link, breadcrumbs }) => {
  if (breadcrumbs.length === 1) {
    return (
      <div className={styles.container}>
        <ContentMapColumnHeader
          movedIn={movedIn}
          link={link}
          topic={breadcrumbs[0]}
        />
      </div>
    );
  }

  const items = breadcrumbs.map((topic, index) => {
    return {
      name:
        index === 0 ? (
          <div className={styles.name}>{topic.name}</div>
        ) : (
          topic.name
        ),
      to: link ? topicPath(topic) : null,
    };
  });

  return (
    <div className={styles.container}>
      <Breadcrumbs truncate size="small" items={items} />
    </div>
  );
};

ContentMapColumnBreadcrumbs.propTypes = propTypes;

export default ContentMapColumnBreadcrumbs;
